import { initConsoleCapture } from '@/lib/console-capture';
import { isBotUserAgent } from '@/lib/is_bot_ua';

initConsoleCapture();

import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import { shouldHydratePrerenderedRoot } from '@/lib/prerender-hydration';
import { SEO_METADATA } from './seo-metadata';
import { PublicMarketingApp } from './public-marketing-app';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const tree = (
  <StrictMode>
    <PublicMarketingApp />
  </StrictMode>
);

const shouldHydrate = shouldHydratePrerenderedRoot({
  rootHasChildren: rootElement.hasChildNodes(),
  currentPathname: window.location.pathname,
  prerenderedRoute: rootElement.getAttribute('data-prerendered-route'),
  prerenderedRoutes: Object.keys(SEO_METADATA),
});

if (shouldHydrate) {
  hydrateRoot(rootElement, tree);
} else {
  if (rootElement.hasChildNodes()) {
    rootElement.replaceChildren();
  }
  createRoot(rootElement).render(tree);
}

if ('serviceWorker' in navigator && !isBotUserAgent(navigator.userAgent)) {
  // Best-effort registration. Some browser extensions wrap
  // `serviceWorker.register` and reject the returned promise; swallow it here
  // so it never surfaces as an unhandled rejection (reported to BQ as
  // "Error: Rejected"). Behaviour on the success path is unchanged.
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}
